module.exports = __webpack_public_path__ + "img/floor3.f2077e25.jpg";